import 'typeface-roboto/index.css';

import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router'

Vue.config.productionTip = false

Vue.filter('float2_0', function (value) {
  let float = parseFloat(value)
  if (isNaN(float) || float === 0) return '0.00'
  return float.toFixed(2)
})

new Vue({
  vuetify,
  store,
  render: h => h(App),
  router,
  beforeCreate () {
    this.$store.commit('initialiseStore')
  }
}).$mount('#app')
